import {
  CREATE_MATERIAL_GROUP,
  LIST_OF_MATERIAL_GROUP,
  MATERIAL_GROUP,
} from "./ApiRoutes";
import { authData } from "./services";

export const listOfMaterialGroup = async (data: object) => {
  const response = await authData.post(LIST_OF_MATERIAL_GROUP, data);
  return response?.data;
};

export const createMaterialGroup = async (data: object) => {
  const response = await authData.post(CREATE_MATERIAL_GROUP, data);
  return response?.data;
};

export const deleteMaterialGroup = async (id: number) => {
  const response = await authData.delete(`${MATERIAL_GROUP}${id}`);
  return response?.data;
};

export const editMaterialGroup = async (id: number, data: object) => {
  const response = await authData.put(`${MATERIAL_GROUP}${id}`, data);
  return response?.data;
};
